export const GuideAcceptanceStatus = {
	NULL: {id: null, name: '--', filterName: ''},
	NOT_SENT:{id: 1, name: 'Não Enviado', filterName: ''},
	WAITING:{id: 2, name: 'Aguardando', filterName: 'Aguardando'},
	REFUSED:{id: 3, name: 'Recusado', filterName: 'Recusada'},
	ACCEPTED:{id: 4, name: 'Aceito', filterName: 'Aceita'},
}



// WEBPACK FOOTER //
// ./src/enums/GuideAcceptanceStatus.js